import { render, staticRenderFns } from "./contact-us.html?vue&type=template&id=52c72fe8&scoped=true&external"
import script from "./contact-us.js?vue&type=script&lang=js&external"
export * from "./contact-us.js?vue&type=script&lang=js&external"
import style0 from "./contact-us.scss?vue&type=style&index=0&id=52c72fe8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c72fe8",
  null
  
)

export default component.exports